import React, { useEffect, useState } from "react";
import { Box, IconButton, CardMedia } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const ImageSlider = ({ images }) => {
  const [imageArray, setImageArray] = useState([]);
  const [leftArrowIconEnable, setLeftArrowIconEnable] = useState(false);
  const [rightArrowIconEnable, setRightArrowIconEnable] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const tempImageArray = [];
    let index = 0;
    Object.entries(images).forEach(([imageType, imageSrc]) => {
      if (imageSrc !== "")
        tempImageArray[index++] = { type: imageType, imageSrc: imageSrc };
    });
    setImageArray(tempImageArray);
    if (tempImageArray.length <= 1) {
      setLeftArrowIconEnable(false);
      setRightArrowIconEnable(false);
    }
  }, []);
  const handleArrowIconDisplay = (activeIndex) => {
    if (activeIndex === imageArray.length - 1) {
      setRightArrowIconEnable(false);
    } else if (activeIndex === 0) {
      setLeftArrowIconEnable(false);
    } else {
      setLeftArrowIconEnable(true);
      setRightArrowIconEnable(true);
    }
  };
  const handleNext = () => {
    let newIndex = activeIndex + 1;
    setActiveIndex(newIndex);
    handleArrowIconDisplay(newIndex);
  };

  const handlePrev = () => {
    let newIndex = activeIndex - 1;
    setActiveIndex(newIndex);
    handleArrowIconDisplay(newIndex);
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: 600,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
      }}
    >
      <CardMedia
        component="img"
        image={imageArray[activeIndex]?.imageSrc || ""}
        sx={{ width: "70%", height: "auto" }}
      />
      <IconButton
        onClick={handlePrev}
        sx={{
          position: "absolute",
          top: "50%",
          left: 0,
          transform: "translateY(-50%)",
          display: leftArrowIconEnable ? "block" : "none",
        }}
      >
        <ArrowBackIos />
      </IconButton>

      <IconButton
        onClick={handleNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: 0,
          transform: "translateY(-50%)",
          display: rightArrowIconEnable ? "block" : "none",
        }}
      >
        <ArrowForwardIos />
      </IconButton>
    </Box>
  );
};

export default ImageSlider;
